import {IonButton, IonIcon} from '@ionic/react';
import {search} from 'ionicons/icons';
import React, {memo} from 'react';

export const SearchIconComponent: React.FC = memo(() => (
  <IonButton routerLink="/search" className="search-icon">
    <IonIcon icon={search}/>
  </IonButton>
));
